const KOKO_EMPTY_IMGS = (window.KOKO_MOOD_URLS && window.KOKO_MOOD_URLS.empty) || [];
const KOKO_MOOD_IMGS  = (window.KOKO_MOOD_URLS) || { low: '', mid: '', high: '' };

function kokoRandomEmptyImg() {
  return KOKO_EMPTY_IMGS[Math.floor(Math.random() * KOKO_EMPTY_IMGS.length)];
}

function kokoMoodImg(itemCount) {
  if (itemCount >= 6) return KOKO_MOOD_IMGS.high;
  if (itemCount >= 3) return KOKO_MOOD_IMGS.mid;
  return KOKO_MOOD_IMGS.low;
}

class KokoCartSidebar extends HTMLElement {
  connectedCallback() {
    const initImg = this.querySelector('#KokoSidebar-EmptyImg');
    if (initImg) initImg.src = kokoRandomEmptyImg();
    this._unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      // publish() avisa a todos los suscriptores, uno mismo incluido. Sin este
      // filtro cada clic en +/- acababa pidiendo /cart.js una vez de más para
      // repintar lo que render() ya había dejado al día.
      if (event && event.source === 'koko-sidebar') return;
      this.refresh();
    });
    this.addEventListener('click', (e) => {
      const btn = e.target.closest('.koko-sidebar__qty-btn');
      if (btn) this.handleQtyChange(btn);
    });
    // El scroll dispara decenas de veces por segundo y positionMoodImg()
    // lee layout (getBoundingClientRect) antes de escribirlo. Sin este
    // candado de rAF, cada evento fuerza un reflow síncrono y el scroll
    // de la home se siente a tirones.
    this._posFrame = null;
    this._positionHandler = () => {
      if (this._posFrame) return;
      this._posFrame = requestAnimationFrame(() => {
        this._posFrame = null;
        this.positionMoodImg();
      });
    };
    window.addEventListener('resize', this._positionHandler);
    window.addEventListener('scroll', this._positionHandler, { passive: true });

    // El sidebar llega pintado por Liquid, pero la imagen del dinosaurio la
    // enciende el JS. Sin esto solo aparecía tras el primer cambio de carrito:
    // en una carga limpia se quedaba oculta aunque hubiera artículos.
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => this.updateMoodImg(cart.item_count))
      .catch(() => {});
  }

  disconnectedCallback() {
    if (this._unsubscribe) this._unsubscribe();
    if (this._posFrame) cancelAnimationFrame(this._posFrame);
    window.removeEventListener('resize', this._positionHandler);
    window.removeEventListener('scroll', this._positionHandler);
  }

  updateMoodImg(itemCount) {
    const img = document.getElementById('KokoSidebar-MoodImgOuter');
    if (!img) return;
    if (!itemCount) {
      img.classList.add('koko-sidebar__mood-img--hidden');
      return;
    }
    img.src = kokoMoodImg(itemCount);
    img.classList.remove('koko-sidebar__mood-img--hidden');
    this.positionMoodImg();
  }

  positionMoodImg() {
    const img = document.getElementById('KokoSidebar-MoodImgOuter');
    if (!img || img.classList.contains('koko-sidebar__mood-img--hidden')) return;

    const rect = this.getBoundingClientRect();
    const ancho = img.offsetWidth || 192;
    const MARGEN = 8;

    // Debajo del panel y centrado, sin montarse: montado tapaba el botón de
    // pagar, que es lo último que conviene esconder. SEPARACION es el aire
    // entre el borde inferior del cuadro y la cabeza del dinosaurio.
    const SEPARACION = 6;

    let izquierda = rect.left + (rect.width - ancho) / 2;
    const arriba = rect.bottom + SEPARACION;

    // A propósito no se limita la vertical. Antes se subía para que cupiera en
    // la ventana, y con la página arriba del todo eso lo dejaba encima del
    // pedido. Ahora va pegado al pie del panel pase lo que pase: si no cabe,
    // queda bajo el pliegue y aparece al bajar. Solo se limita la horizontal,
    // que nunca deja de estar a la vista.
    const topeX = window.innerWidth - ancho - MARGEN;
    izquierda = Math.max(MARGEN, Math.min(izquierda, Math.max(MARGEN, topeX)));

    img.style.left = `${Math.round(izquierda)}px`;
    img.style.top  = `${Math.round(arriba)}px`;
  }

  async handleQtyChange(btn) {
    const key = btn.dataset.key;
    const action = btn.dataset.action;
    const controles = btn.closest('.koko-sidebar__qty-controls');
    const numEl = controles.querySelector('.koko-sidebar__qty-num');
    const currentQty = parseInt(numEl.textContent, 10);
    if (Number.isNaN(currentQty)) return;

    const newQty = action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);
    if (newQty === currentQty) return;

    // Respuesta inmediata al clic, pero sin tocar las cifras: pintar la cantidad
    // por adelantado dejaba la fila incoherente (7x con el importe de 5) y las
    // filas que bajaban a cero se quedaban a la vista con $0.00. La fila se
    // atenúa mientras viaja la petición y las cifras las escribe solo render(),
    // con lo que responda el servidor.
    const fila = btn.closest('.koko-sidebar__item');
    if (fila) fila.style.opacity = '0.55';

    const botones = controles.querySelectorAll('.koko-sidebar__qty-btn');
    botones.forEach((b) => { b.disabled = true; });

    // Con clics rápidos las respuestas pueden llegar desordenadas; solo el
    // último cambio tiene derecho a repintar.
    const turno = (this._turnoQty = (this._turnoQty || 0) + 1);

    try {
      // change.js ya devuelve el carrito actualizado: el /cart.js que venía
      // después era un viaje de más en cada clic.
      const respuesta = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty }),
      });
      if (!respuesta.ok) throw new Error('cart/change respondió ' + respuesta.status);

      const cart = await respuesta.json();
      if (turno !== this._turnoQty) return;

      this.render(cart);
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'koko-sidebar' });
    } catch (e) {
      // Deshacer el pintado optimista con lo que diga el servidor.
      if (turno === this._turnoQty) this.refresh();
    } finally {
      // Si render() corrió, estos nodos ya están fuera del DOM y esto no hace
      // nada. Si hubo error siguen siendo los de pantalla y hay que revivirlos.
      botones.forEach((b) => { b.disabled = false; });
      if (fila) fila.style.removeProperty('opacity');
    }
  }

  async refresh() {
    const cart = await fetch('/cart.js').then((r) => r.json());
    this.render(cart);
  }

  animateCount(el, fromValue, toValue, duration, formatter) {
    if (el._animFrame) cancelAnimationFrame(el._animFrame);
    const start = performance.now();
    const range = toValue - fromValue;
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = formatter(fromValue + eased * range);
      if (p < 1) {
        el._animFrame = requestAnimationFrame(tick);
      } else {
        el._animFrame = null;
      }
    };
    el._animFrame = requestAnimationFrame(tick);
  }

  itemHTML(item) {
    const imgUrl = item.featured_image?.url
      ? item.featured_image.url.replace(/(\.\w+)(\?|$)/, '_120x120$1$2')
      : '';
    const title = item.product_title.toUpperCase();
    const shortTitle = title.length > 28 ? title.slice(0, 28) + '…' : title;
    const variantLine =
      item.variant_title && item.variant_title !== 'Default Title'
        ? `<p class="koko-sidebar__item-variant">${item.variant_title}</p>`
        : '';
    return `
      <div class="koko-sidebar__item" data-key="${item.key}">
        ${imgUrl ? `<div class="koko-sidebar__item-img"><img src="${imgUrl}" alt="${item.product_title}" width="56" height="56" loading="lazy"></div>` : ''}
        <div class="koko-sidebar__item-body">
          <div class="koko-sidebar__item-row">
            <p class="koko-sidebar__item-name">
              <strong class="koko-sidebar__item-qty-label" data-qty="${item.quantity}">${item.quantity}x</strong>
              ${shortTitle}
            </p>
            <span class="koko-sidebar__item-total" data-cents="${item.final_line_price}">${this.money(item.final_line_price)}</span>
          </div>
          ${variantLine}
          <div class="koko-sidebar__item-footer">
            <span class="koko-sidebar__item-price">${this.money(item.final_price)} c/u</span>
            <div class="koko-sidebar__qty-controls">
              <button class="koko-sidebar__qty-btn" data-action="decrease" data-key="${item.key}" aria-label="Disminuir" type="button">−</button>
              <span class="koko-sidebar__qty-num" data-qty="${item.quantity}">${item.quantity}</span>
              <button class="koko-sidebar__qty-btn" data-action="increase" data-key="${item.key}" aria-label="Aumentar" type="button">+</button>
            </div>
          </div>
        </div>
      </div>`;
  }

  render(cart) {
    const itemsEl = this.querySelector('#KokoSidebar-Items');
    const countEl = this.querySelector('#KokoSidebar-Count');
    const footerEl = this.querySelector('.koko-sidebar__footer');
    const dashEl = this.querySelector('.koko-ticket-dash');

    if (countEl) {
      countEl.textContent =
        cart.item_count === 0 ? 'Vacío' : cart.item_count === 1 ? '1 artículo' : `${cart.item_count} artículos`;
    }

    if (cart.item_count === 0) {
      this.classList.add('koko-sidebar--empty');
      if (itemsEl) itemsEl.innerHTML = `
        <div class="koko-sidebar__empty-state">
          <img class="koko-sidebar__empty-img" src="${kokoRandomEmptyImg()}" alt="Carrito vacío">
          <p>Agrega productos al carrito</p>
          <p class="koko-sidebar__empty-hint">Usa el botón <strong>+</strong> en cada producto</p>
        </div>`;
      if (dashEl) dashEl.style.display = 'none';
      if (footerEl) footerEl.innerHTML = `
        <div class="koko-sidebar__total-row" style="display:none"></div>
        <div class="koko-sidebar__ctas" style="display:none"></div>`;
      this.updateMoodImg(0);
      return;
    }

    this.classList.remove('koko-sidebar--empty');
    if (dashEl) dashEl.style.display = '';

    // Limpiar el estado vacío si aún existe
    if (itemsEl) {
      const emptyState = itemsEl.querySelector('.koko-sidebar__empty-state');
      if (emptyState) emptyState.remove();
    }

    // Shopify puede devolver líneas con cantidad 0 —pasa cuando el producto se
    // queda sin stock: la línea sobrevive en el carrito pero ya no cuenta para
    // item_count ni para el total. Pintarlas dejaba filas fantasma en "0X" y
    // "$0.00" que el cliente nunca había pedido.
    const itemsVivos = (cart.items || []).filter((i) => i.quantity > 0);

    // — Diff items: solo tocar los que cambiaron —
    if (itemsEl) {
      const existingKeys = new Set(
        [...itemsEl.querySelectorAll('.koko-sidebar__item')].map((el) => el.dataset.key)
      );
      const newKeys = new Set(itemsVivos.map((i) => i.key));

      // Eliminar items que ya no están en el carrito
      existingKeys.forEach((key) => {
        if (!newKeys.has(key)) {
          itemsEl.querySelector(`[data-key="${key}"]`)?.remove();
        }
      });

      itemsVivos.forEach((item, idx) => {
        const existingRow = itemsEl.querySelector(`.koko-sidebar__item[data-key="${item.key}"]`);

        if (!existingRow) {
          // Item nuevo: insertar en posición correcta y animar desde 0
          const tmp = document.createElement('div');
          tmp.innerHTML = this.itemHTML(item).trim();
          const newRow = tmp.firstChild;
          const rows = itemsEl.querySelectorAll('.koko-sidebar__item');
          if (rows[idx]) {
            itemsEl.insertBefore(newRow, rows[idx]);
          } else {
            itemsEl.appendChild(newRow);
          }
          const qtyLabel = newRow.querySelector('.koko-sidebar__item-qty-label');
          const qtyNum = newRow.querySelector('.koko-sidebar__qty-num');
          const totalEl = newRow.querySelector('.koko-sidebar__item-total');
          if (qtyLabel) this.animateCount(qtyLabel, 0, item.quantity, 500, (n) => `${Math.round(n)}x`);
          if (qtyNum) this.animateCount(qtyNum, 0, item.quantity, 500, (n) => Math.round(n));
          if (totalEl) this.animateCount(totalEl, 0, item.final_line_price / 100, 600, (n) => this.money(Math.round(n * 100)));
        } else {
          // Item existente: solo animar si cambió la cantidad
          const prevQty = parseInt(existingRow.querySelector('.koko-sidebar__qty-num')?.dataset.qty || '0');
          if (prevQty !== item.quantity) {
            const qtyLabel = existingRow.querySelector('.koko-sidebar__item-qty-label');
            const qtyNum = existingRow.querySelector('.koko-sidebar__qty-num');
            const totalEl = existingRow.querySelector('.koko-sidebar__item-total');
            const prevTotal = parseInt(totalEl?.dataset.cents || '0');

            if (qtyLabel) this.animateCount(qtyLabel, prevQty, item.quantity, 400, (n) => `${Math.round(n)}x`);
            if (qtyNum) this.animateCount(qtyNum, prevQty, item.quantity, 400, (n) => Math.round(n));
            if (totalEl) {
              this.animateCount(totalEl, prevTotal / 100, item.final_line_price / 100, 500, (n) => this.money(Math.round(n * 100)));
              totalEl.dataset.cents = item.final_line_price;
            }
            if (qtyLabel) qtyLabel.dataset.qty = item.quantity;
            if (qtyNum) qtyNum.dataset.qty = item.quantity;

            // Re-habilitar botones
            existingRow.querySelectorAll('.koko-sidebar__qty-btn').forEach((b) => (b.disabled = false));
          }
        }
      });
    }

    // — Actualizar total solo si cambió —
    if (footerEl) {
      let totalEl = footerEl.querySelector('.koko-sidebar__total-value');
      if (!totalEl) {
        footerEl.innerHTML = `
          <div class="koko-sidebar__total-row">
            <span class="koko-sidebar__total-label">Total estimado</span>
            <span class="koko-sidebar__total-value" data-cents="${cart.total_price}">${this.moneyWithCurrency(cart.total_price)}</span>
          </div>
          <div class="koko-sidebar__ctas">
            <a href="/cart" class="koko-sidebar__btn koko-sidebar__btn--secondary">Ver carrito</a>
            <a href="/checkout" class="koko-sidebar__btn koko-sidebar__btn--primary">Pagar ahora</a>
          </div>`;
      } else {
        const prevTotal = parseInt(totalEl.dataset.cents || '0');
        if (prevTotal !== cart.total_price) {
          this.animateCount(totalEl, prevTotal / 100, cart.total_price / 100, 600, (n) => this.moneyWithCurrency(Math.round(n * 100)));
          totalEl.dataset.cents = cart.total_price;
        }
      }
    }

    // Al final y no al principio: el dinosaurio se ancla al pie del panel, así
    // que hay que colocarlo cuando la lista ya tiene su altura definitiva. Si se
    // hacía antes de repintar, quedaba a la altura del panel anterior y se
    // montaba sobre el botón de pagar.
    this.updateMoodImg(cart.item_count);
  }

  money(cents) {
    return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(cents / 100);
  }

  moneyWithCurrency(cents) {
    return `${this.money(cents)} MXN`;
  }
}

customElements.define('koko-cart-sidebar', KokoCartSidebar);
